// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d4c9982d","498":"2c65c4e8","703":"ea0ec69f"}[chunkId] + ".chunk.js";
};